const colors = {
  primary: '#3F51B5',
  primary100: '#C5CAE9',
  primary300: '#7986CB',
  primary500: '#3F51B5',
  primary700: '#303F9F',
  primary900: '#1A237E',
  grey100: '#CFD8DC',
  grey300: '#90A4AE',
  grey500: '#607D8B',
  grey700: '#455A64',
  grey900: '#263238',
};

export default colors;
